import {Ticket} from "src/app/core/entities/ticket/domain/model/ticket.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class AccountInvoiceReceivedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'AccountInvoiceReceivedEvent';

  constructor(readonly payload: Ticket) {
  }
}
